<ng-container>
  <div class="book-flights-cta" *ngIf="flightsPageRedirectionUrl$ | async as flightsPageUrl">
    <a id="bookNowButton" class="btn bold-type no-underline" [finLink]="flightsPageUrl" [external]="true"
      >{{ 'bookNow' | finLocalization }}
    </a>
  </div>

  <div class="mr-xxsmall-t section col-1-12 md-col-2-11">
    <div
      #widget
      id="iata-timatic-widget"
      (finMutationObserver)="onWidgetChange(isMobile())"
      mutationObserverInitConfigKey="travelRestrictions"
    ></div>
  </div>
</ng-container>
